/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_EmptyInputs */

const vi_customer_group_empty = /** @type {(inputs: Customer_Group_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có nhóm khách hàng nào`)
};

/**

* @param {Customer_Group_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_empty = /** @type {((inputs?: Customer_Group_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_empty(inputs)
});